import { Link } from 'react-router-dom';

interface UpgradePromptProps {
  /** Human-readable name of the gated feature, e.g. "Webhooks". */
  feature: string;
  /** Optional plan that unlocks it (shown when known). */
  requiredPlan?: string;
}

/**
 * Inline notice shown when the tenant's plan does not include a feature. Explains the gate and links
 * to the Licencia tab so the user can see their plan. Purely informative — there is no self-service
 * checkout yet, so it nudges rather than performing an upgrade.
 */
export function UpgradePrompt({ feature, requiredPlan }: UpgradePromptProps): JSX.Element {
  return (
    <div
      className="flex items-start gap-3 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900"
      role="note"
      data-testid="upgrade-prompt"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="mt-0.5 h-5 w-5 shrink-0">
        <rect x="5" y="11" width="14" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
      </svg>
      <div>
        <p className="font-medium">
          {feature} no está disponible en tu plan actual
          {requiredPlan !== undefined ? ` (requiere ${requiredPlan})` : ''}.
        </p>
        <p className="mt-0.5 text-amber-800">
          Consulta tu plan en la{' '}
          <Link to="?tab=license" className="font-medium underline hover:no-underline">
            pestaña Licencia
          </Link>{' '}
          para ver qué incluye y cómo ampliarlo.
        </p>
      </div>
    </div>
  );
}
